import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[appBlurOnClick]'
})
export class BlurOnClickDirective {
  @HostListener('click', ['$event.target']) onClick(target: HTMLElement) {
    target.blur(); // Supprime le focus visuel immédiatement après le clic
  }
}
